import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Link from '~/components/Link/Link';
import config from '~/config';

const Container = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
`;

const SeeMoreImage = styled.img`
  display: block;
  height: auto;
  width: 100%;
  filter: blur(3px) brightness(0.7);
`;

const SeeMoreTextContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SeeMoreText = styled.h3`
  color: ${props => props.theme.white};
  font-weight: 700;
  font-size: 24px;
  @media (max-width: 600px) {
    font-size: 18px;
  }
`;

const SeeMoreCard = props => {
  const { seeMore } = props;
  return (
    <Link to={seeMore}>
      <Container>
        <SeeMoreImage
          src={`${config.assetPath}/static/images/Card/trip.jpg`}
          alt="See more trips"
        />
        <SeeMoreTextContainer>
          <SeeMoreText>See More</SeeMoreText>
        </SeeMoreTextContainer>
      </Container>
    </Link>
  );
};

SeeMoreCard.propTypes = {
  seeMore: PropTypes.string,
};

export default SeeMoreCard;
